export default function CaretUp({ className = "" }) {
  return (
    <svg
      className={`caret-up ${className}`}
      width="28"
      height="15"
      viewBox="0 0 28 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26 13.2L14 1.19995L2 13.2"
        stroke="currentColor"
        stroke-width="3"
        stroke-linejoin="bevel"
      />
    </svg>
  );
}
